import { useCallback } from 'react'
import { playPrimedSubmitSound } from '@/components/user-profile/code-editor-settings'
import { useUserSettings } from '@/components/user-settings-context'
import { useExecutionOptional } from '../execution-context'
import { useSubmissionSuccess } from '../hooks/use-submission-success'

/**
 * Render-less component that plays the user's selected success submit sound
 * when a fully passing submission is detected.
 *
 * Timer/stopwatch lifecycle (pause, reset, DB persistence) is handled by
 * onSessionComplete() called from handleSubmit in use-monaco-editor.ts.
 * This component must NOT touch timer state — doing so would overwrite the
 * correct time windows that onSessionComplete already persisted.
 */
export function TimerSubmissionWatcher() {
  const executionCtx = useExecutionOptional()
  const { settings } = useUserSettings()

  const handleSuccess = useCallback(
    (_executionId: string | null) => {
      playPrimedSubmitSound(settings.editor.successSubmitSound)
    },
    [settings.editor.successSubmitSound],
  )

  useSubmissionSuccess({
    executionResult: executionCtx?.result ?? null,
    executionMode: executionCtx?.executionMode ?? null,
    isExecuting: executionCtx?.isExecuting ?? false,
    onSuccess: handleSuccess,
  })

  return null
}
